"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _clsx = _interopRequireDefault(require("clsx"));
var _lodash = require("lodash");
var _core = require("@material-ui/core");
var _reactI18next = require("react-i18next");
var _pageContext = _interopRequireDefault(require("../../context/pageContext"));
var _svgicon = _interopRequireDefault(require("../../helper/svgicon"));
var _searchField = _interopRequireDefault(require("../search-field"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _core.makeStyles)(theme => {
  var _theme$palette$foregr, _theme$palette$foregr2, _theme$palette$foregr3;
  return {
    container: {
      padding: theme.spacing(4, 2)
    },
    searchWrapper: {
      marginBottom: theme.spacing(4)
    },
    link: {
      background: "#FFFFFF",
      color: (_theme$palette$foregr = theme.palette.foreground) === null || _theme$palette$foregr === void 0 || (_theme$palette$foregr = _theme$palette$foregr.menu) === null || _theme$palette$foregr === void 0 ? void 0 : _theme$palette$foregr.navigation,
      display: "block",
      paddingTop: "83.3333%",
      position: "relative",
      textAlign: "center",
      transitionProperty: "color",
      transitionDuration: theme.transitions.duration.standard,
      transitionTimingFunction: theme.transitions.easing.sharp,
      "&:hover": {
        color: (_theme$palette$foregr2 = theme.palette.foreground) === null || _theme$palette$foregr2 === void 0 || (_theme$palette$foregr2 = _theme$palette$foregr2.menu) === null || _theme$palette$foregr2 === void 0 ? void 0 : _theme$palette$foregr2.navigationHover
      },
      [theme.breakpoints.up("lg")]: {
        paddingTop: "70%"
      }
    },
    linkSelected: {
      color: (_theme$palette$foregr3 = theme.palette.foreground) === null || _theme$palette$foregr3 === void 0 || (_theme$palette$foregr3 = _theme$palette$foregr3.menu) === null || _theme$palette$foregr3 === void 0 ? void 0 : _theme$palette$foregr3.navigationSelected
    },
    content: {
      alignItems: "center",
      bottom: 0,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      left: 0,
      padding: theme.spacing(1),
      position: "absolute",
      right: 0,
      top: 0,
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(2)
      }
    },
    iconWrapper: {
      alignItems: "center",
      display: "flex",
      height: 40,
      justifyContent: "center",
      width: 40
    },
    linkTitle: {
      fontWeight: theme.typography.fontWeightBold,
      hyphens: "auto",
      margin: theme.spacing(1, 0, 0, 0),
      lineHeight: 1
    }
  };
});
const MenuTree = () => {
  const {
    REACT_APP_MAINNAV
  } = process.env;
  const [pageData] = (0, _react.useContext)(_pageContext.default);
  const {
    menuGroups
  } = pageData.data;
  const {
    t,
    i18n
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  const menuGroupForHeaderBar = (0, _lodash.find)(menuGroups, function (o) {
    return o.title === REACT_APP_MAINNAV;
  });
  const handleSearch = value => {
    if (!value) return;
    window.location.href = "/".concat(i18n.language, "/search/").concat(value === null || value === void 0 ? void 0 : value.title);
  };
  return /*#__PURE__*/_react.default.createElement(_core.Container, {
    className: css.container
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: css.searchWrapper
  }, " ", /*#__PURE__*/_react.default.createElement(_searchField.default, {
    intentions: true,
    placeholder: t("site.ui.search.placeholders.default"),
    background: "#FFFFFF",
    onChange: handleSearch
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 2
  }, menuGroupForHeaderBar === null || menuGroupForHeaderBar === void 0 ? void 0 : menuGroupForHeaderBar.items.map((item, index) => /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 6,
    sm: 4,
    md: 3,
    key: index
  }, /*#__PURE__*/_react.default.createElement(MenuTreeItem, {
    item: item
  })))));
};
const MenuTreeItem = props => {
  const {
    item
  } = props;
  const {
    icon,
    link,
    selected,
    title
  } = item;
  const {
    REACT_APP_PATH
  } = process.env;
  const css = useStyles();
  const DetectLink = props => {
    if (link.indexOf("http://") > -1 || link.indexOf("https://") > -1) {
      return /*#__PURE__*/_react.default.createElement("a", {
        className: (0, _clsx.default)({
          [css.link]: true,
          [css.linkSelected]: selected
        }),
        href: link !== null && link !== void 0 ? link : "/",
        target: "_blank",
        rel: "noreferrer"
      }, props.children);
    } else {
      return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        className: (0, _clsx.default)({
          [css.link]: true,
          [css.linkSelected]: selected
        }),
        to: link !== null && link !== void 0 ? link : "/"
      }, props.children);
    }
  };
  return /*#__PURE__*/_react.default.createElement(DetectLink, null, /*#__PURE__*/_react.default.createElement("div", {
    className: css.content
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: css.iconWrapper
  }, icon !== null && icon !== void 0 && icon.filename ? /*#__PURE__*/_react.default.createElement(_svgicon.default, {
    src: REACT_APP_PATH + icon.filename,
    size: 32
  }) : ""), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.linkTitle,
    variant: "body2"
  }, title)));
};
var _default = exports.default = MenuTree;